module.exports = __webpack_public_path__ + "static/media/redemption-gift-soft-tape.d8d6966a.png";